import { useTranslation } from 'react-i18next';
import React, { useEffect, useState } from 'react';
import { useRecoveryService } from 'app/utils/services/recoveryService';
import useRedirectWithFormId from 'app/utils/customHooks/useRedirectWithFormId';
import { useForm } from 'react-hook-form';
import { useLocation } from 'react-router-dom';

const useNewPass = () => {
  const { t } = useTranslation();
  const [password, setPassword] = useState('');
  const [checkPassword, setCheckPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [showCheckPassword, setShowCheckPassword] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [openSnackbar, setOpenSnackbar] = useState(false);

  const location = useLocation();
  const data = location.state;

  const { isLoadingRecovery, dataRecovery, recoveryMutation } = useRecoveryService();
  const { handleRedirect } = useRedirectWithFormId();
  const { handleSubmit, register } = useForm();

  useEffect(() => {
    if (dataRecovery?.result === 'success') {
      setShowModal(true);
    }

    if (dataRecovery?.result === 'error') {
      setOpenSnackbar(true);
    }
  }, [dataRecovery]);

  const handleClickShowPassword = () => setShowPassword((show) => !show);
  const handleClickShowCheckPassword = () => setShowCheckPassword(!showCheckPassword);

  const handleMouseDownPassword = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
  };
  const handleMouseDownCheckPassword = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
  };

  const handleChangePassword = (event: any) => {
    setPassword(event.target.value);
  };
  const handleChangeCheckPassword = (event: any) => {
    setCheckPassword(event.target.value);
  };

  const handleOnSubmit = () => {
    recoveryMutation({
      data: {
        password: btoa(password),
      },
      url: `${data?.path_url}?business_key=${data?.business_key}`,
    });
  };

  const handleSubmitForm = handleSubmit(handleOnSubmit);

  return {
    t,
    isLoadingRecovery,
    password,
    showPassword,
    showModal,
    handleSubmitForm,
    handleChangePassword,
    handleClickShowPassword,
    handleMouseDownPassword,
    checkPassword,
    handleChangeCheckPassword,
    handleClickShowCheckPassword,
    showCheckPassword,
    handleMouseDownCheckPassword,
    openSnackbar,
    setOpenSnackbar,
    dataRecovery,
  };
};

export default useNewPass;
